import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'lg' | 'xl';
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  href = '#resumen-oferta'
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 rounded-sm cursor-pointer';
  const variants = {
    primary: 'bg-[#FF6B00] text-white hover:bg-[#FF8C00] border border-[#FF6B00] hover:border-[#FF8C00]',
    secondary: 'bg-transparent text-[#FF6B00] border-2 border-[#FF6B00] hover:bg-[#FF6B00]/10'
  };
  const sizes = {
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl md:text-2xl'
  };
  const glowEffect = variant === 'primary' ? 'shadow-[0_0_20px_rgba(255,107,0,0.3)] hover:shadow-[0_0_30px_rgba(255,107,0,0.6)]' : '';
  const handleClick = () => {
    if (href.includes('carlosponte.com/cart/add')) {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    }
  };
  return <motion.a href={href} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${glowEffect} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-57">
      {children}
      <ArrowRight className={`ml-2 ${size === 'xl' ? 'w-6 h-6' : 'w-5 h-5'}`} data-id="element-58" />
    </motion.a>;
}